import { CameraSession } from '@helpers/session';

export function useCameraSession() {
  return new CameraSession();
}
